import {AuditEvent, PolicyRoutesEnum} from 'interfaces'
import BoxIcon from 'assets/cac-icons/box.webp'
import CiscoWebexIcon from 'assets/cac-icons/webex.webp'
import DropboxIcon from 'assets/cac-icons/dropbox.webp'
import GoogleIcon from 'assets/cac-icons/google.webp'
import Microsoft365Icon from 'assets/cac-icons/microsoft.webp'
import SalesforceIcon from 'assets/cac-icons/salesforce.webp'
import SlackIcon from 'assets/cac-icons/slack.webp'

export const policyRightPanelViewConst = {
  default: 'default',
  addPolicy: 'addPolicy',
  policyDetails: 'policyDetails',
  policyTester: 'policyTester',
}

// Timeouts
export const ms100 = 100
export const ms150 = 150
export const ms200 = 200
export const ms300 = 300
export const ms500 = 500
export const secs2 = 2000
export const secs5 = 5000
export const secs10 = 10000
export const secs25 = 25000
export const secs30 = 30000
export const secs35 = 35000
export const min1 = 60000

export const whiteSpaceRegEx = /(\r\n|\n|\r|\s)/gm
export const trailingSlashRegEx = /\/$/g
export const searchHeaderEveryone = 'Everyone'
export const emptyString = ''
export const SPARKLE_EMOJI = '✨'
export const CHECKMARK_SYMBOL = '✓'
export const ARROW_RIGHT_SYMBOL = '→'

export const num0 = 0,
  num2 = 2,
  num5 = 5,
  num24 = 24,
  num32 = 32,
  num60 = 60,
  num72 = 72,
  num90 = 90,
  num1000 = 1000,
  num1500 = 1500

export const POLICY_OR_CATEGORY_NAME_MAX_LENGTH = 256
export const policyOrCategoryNameMaxLengthError = `Only ${POLICY_OR_CATEGORY_NAME_MAX_LENGTH} characters allowed`

export const textWhite = 'text-white'
export const fillColorNone = '#00000000'
export const round = 'round'
export const emailId = 'emailId'

export enum CloudAppId {
  Box = 'box',
  Slack = 'slack',
  Claude = 'claude',
  GitHub = 'github',
}

/** @deprecated Use CloudAppId enum instead */
export const cloudAppId = CloudAppId

export const githubEnterpriseIdHelpUrl =
  'https://docs.github.com/en/enterprise-cloud@latest/admin/configuring-settings/hardening-security-for-your-enterprise/restricting-access-to-githubcom-using-a-corporate-proxy#finding-the-header'

export const inviteAdminsHelpUrl =
  'https://inflight.dope.security/dope.console/settings/general#inviting-admins'

export const settingsUsersRoute = '/settings/users'

export const noOperation = () => null

export const basePolicyRoutes = [
  '/policies/content',
  '/policies/cloudapp',
  '/policies/bypass',
  PolicyRoutesEnum.DLP,
]
export const tailwindClassesName = [
  'bg-purple-400 border-purple-400',
  'gray-500 bg-gray-400 bg-gray-1200 border-gray-500',
  'bg-opacity-50 bg-opacity-40 hover:bg-opacity-40 hover:bg-opacity-50',
  'bg-red-100 border-red-100',
  'bg-green-100 bg-green-200 border-green-100 border-green-200',
  'bg-yellow-100 yellow-100 border-yellow-100 border-yellow-400',
  'bg-dope-cyan-200 border-dope-cyan-200',
  'border-l-blue-1100 border-l-purple-1500 border-l-purple-1000 border-l-dope-purple-400 border-l-dope-purple-50 border-l-yellow-100 border-l-green-100',
]
export const windowsApplicationExtensions = ['.msi', '.exe', '.com', '.scr']

// regex
export const specialCharacterAtStartRegEx =
  /^[`~!@#$%^&*()_|+\-=?;:'",<>{}[\]\\]/

export const matchBracketsOnEdgesRegEx = /^[[\]]|[[\]]$/g

export enum HTTP_STATUS_CODE {
  NO_CONTENT = 204,
}

// browser names
export const browserNames = {
  firefox: 'Firefox',
  chrome: 'Chrome',
  edge: 'Edge',
  MSIE: 'MSIE',
  Trident: 'Trident/7',
  IE: 'IE',
  safari: 'Safari',
}

// color codes, alphabetical order - need to extract this to themes
export const colorCodes = {
  blueDark: '#001764',
  blue1300: '#2f5ebd',
  black: '#000',
  brightMagenta: '#F150FF',
  byzantine: '#BB33B5',
  coral: '#FA8553',
  cyanBright: '#4BD1FF',
  cyanDark: '#00AEEA',
  cyan200: '#00BEFF',
  cyan300: '#8BE1FF',
  cyan600: '#01AEEA',
  cyan700: '#81DAF8',
  cyberGrape: '#62456F',
  darkBrown: '#262A31',
  darkBrown2: '#684A12',
  darkIndigo: '#1f1533bf',
  darkPurple: '#261836',
  darkPurple2: '#2F1736',
  darkPurple3: '#281636',
  darkPurple4: '#331f4f',
  darkPurple5: '#7d3bd3',
  deepEggplantPurple: '#2e1836',
  deepMagenta: '#A00059bf',
  dopeBlack: '#090909',
  dopeBlue500: '#039af4',
  dopeIce: '#66F4DA',
  dopeGray1500: '#333',
  dopeGray1200: '#222',
  duskyLavender: '#62519A',
  eerieBlack: '#190B26',
  emeralde: '#00D37E',
  endpointError: 'rgba(248,113,113,0.3)',
  endpointHealthy: 'rgba(102,244,218,0.3)',
  endpointViolation: 'rgba(251,191,36,0.3)',
  gray20: '#F1F3F4',
  gray50: '#1E242B',
  gray200: '#f2f2f2',
  gray600: '#6c6c6c',
  gray800: '#222222',
  gray900: '#151515',
  gray1000: '#919699',
  gray1100: '#5E6366',
  gray1200: '#3D434A',
  gray1400: '#1B1B1B',
  gray1500: '#383838',
  green100: '#00D37E',
  green1200: '#009056',
  imperial: '#56306F',
  indigoGray: '#333248',
  lavenderIndigo: '#A0FF50',
  lavenderIndigoRGBA: (opacity: number) => `rgba(175, 80, 255, ${opacity})`,
  lightLavender: '#D4A0FF',
  oceanBlue: '#5239C4',
  purple50: '#D4A0FF',
  purple400: '#AF50FF',
  purple500: '#604CBF',
  purple600: '#8B73FF',
  purple700: '#5A61EF',
  purple800: '#4930bb',
  persianIndigoRGBA: (opacity: number) => `rgba(46, 21, 102, ${opacity})`,
  mediumSlateBlue: '#7680FF',
  purpleHaze: '#47347D',
  raisinBlack: '#1F1427',
  red100: '#FF685F',
  red400: '#f87171',
  red500: '#ef4444',
  red1000: '#FE2357',
  red1100: '#FF7495',
  regalia: '#47347D',
  regalia2: '#4C3681',
  royalPurple: '#604CBFbf',
  russianViolet: '#2D1F45',
  softCoralRed: '#FF685Fcc',
  spanishViolet: '#3E2F83',
  sunnyYellow: '#F7C839',
  superPink: '#D55EAB',
  teal100: '#082027',
  teal200: '#083747',
  teal300: '#054f68',
  teal400: '#073B4D',
  veryLightBlue: '#5A61EF',
  veryLightBlue2: '#5960EE',
  veryLightBlue3: '#5B62EF',
  majorelleBlue: '#5d35db',
  vibrantCoral: '#E2423E',
  vividLavender: '#AF50FF',
  white: '#ffffff',
  yellow100: '#F7C839',
  yellow1000: '#FCE7A7',
  cornflowerBlue: (opacity: number) => `rgba(125, 144, 255, ${opacity})`, // Base color for "Other" shared files.
  vividCerulean: (opacity: number) => `rgba(1, 174, 234, ${opacity})`, // Base color for "Externally" classified files.
}

export const auditEvents: AuditEvent[] = [
  {
    category: 'Admin Management',
    types: [
      'Admin Added',
      'Admin Removed',
      'Admin Updated',
      'Logged In',
      'Logged Out',
    ],
    uiTexts: {
      adminAdded: 'Admin Added',
      adminRemoved: 'Admin Removed',
      adminUpdated: 'Admin Updated',
      adminLogin: 'Logged In',
      adminLogout: 'Logged Out',
    },
  },
  {
    category: 'User/Group Updates',
    types: ['Initial import', 'Delta import', 'Import Errors'],
    uiTexts: {
      importInitial: 'Initial import',
      importDelta: 'Delta import',
      importFailure: 'Import Errors',
    },
  },
  {
    category: 'Endpoint Configuration',
    types: [
      'Anti Tamper Password Configured',
      'Anti Tamper Password Update',
      'Fail closed ON',
      'Fail closed OFF',
    ],
    uiTexts: {
      antiTamperPasswordConfigured: 'Anti Tamper Password Configured',
      antiTamperPasswordChanged: 'Anti Tamper Password Update',
      endpointFailClosedOn: 'Fail closed ON',
      endpointFailClosedOff: 'Fail closed OFF',
    },
  },
  {
    category: 'OIDC Configuration',
    types: ['OIDC Enabled', 'OIDC Disabled', 'OIDC Config Updated'],
    uiTexts: {
      OIDCConfigEnabled: 'OIDC Enabled',
      OIDCConfigDisabled: 'OIDC Disabled',
      OIDCConfigUpdated: 'OIDC Config Updated',
    },
  },
  {
    category: 'Block Page updates',
    types: ['Block Page Added', 'Block Page Deleted', 'Block Page Changed'],
    uiTexts: {
      blockPageAdded: 'Block Page Added',
      blockPageDeleted: 'Block Page Deleted',
      blockPageChanged: 'Block Page Changed',
    },
  },
  {
    category: 'SIEM Integration',
    types: [
      'SIEM Integration Enabled',
      'SIEM Integration Disabled',
      'SIEM S3 Connection Returned',
      'SIEM S3 Connection Lost',
    ],
    uiTexts: {
      SIEMIntegrationEnabled: 'SIEM Integration Enabled',
      SIEMIntegrationDisabled: 'SIEM Integration Disabled',
      SIEMSyncRecovered: 'SIEM S3 Connection Returned',
      SIEMSyncFailed: 'SIEM S3 Connection Lost',
    },
  },
  {
    category: 'Policy',
    types: ['Policy Updated', 'Policy Created', 'Policy Deleted'],
    uiTexts: {
      policyUpdated: 'Policy Updated',
      policyCreate: 'Policy Created',
      policyDeleted: 'Policy Deleted',
    },
  },
  {
    category: 'CAC',
    types: ['CAC Updated'],
    uiTexts: {
      CACUpdated: 'CAC Updated',
    },
  },
  {
    category: 'Bypass',
    types: ['Bypass Updated'],
    uiTexts: {
      bypassUpdated: 'Bypass Updated',
    },
  },
  {
    category: 'User Assignment',
    types: ['Policy Assigned', 'Policy Unassigned', 'Policy Clash'],
    uiTexts: {
      policyAssigned: 'Policy Assigned',
      policyUnassigned: 'Policy Unassigned',
      policyClash: 'Policy Clash',
    },
  },
  {
    category: 'Endpoint Manager',
    types: [
      'Device Added',
      'Dormant Device Deleted',
      'Device Uninstalled',
      'Device Moved To Debug Mode',
      'Device Exited From Debug Mode',
    ],
    uiTexts: {
      deviceAdded: 'Device Added',
      dormantDeviceDeleted: 'Dormant Device Deleted',
      deviceUninstalled: 'Device Uninstalled',
      deviceMovedToDebugMode: 'Device Moved To Debug Mode',
      deviceExitedFromDebugMode: 'Device Exited From Debug Mode',
    },
  },
  {
    category: 'Analytics',
    types: ['Export of CSV'],
    uiTexts: {
      exportOfCSV: 'Export of CSV',
    },
  },
]

// TODO: remove this in policy management contraction
export const categoryType = {
  custom: 'custom',
  default: 'default',
}

export const categoryState = {
  Allowed: 'Allowed',
  Blocked: 'Blocked',
  Warning: 'Warning',
  Ignore: 'Ignore',
  Mixed: 'Mixed',
}

export const dopeTitleSEO = 'dope.security'

export const dopeSalesEmail = 'sales@dope.security'
export const DOPE_PRIMARY_DOMAIN = 'dope.security'

// Internal test tenants for QA purposes
export const INTERNAL_TEST_TENANTS = [
  'swgtest.onmicrosoft.com',
  'infotechoutreach.onmicrosoft.com',
]

export const defaultBlockPageRegEx = {
  scriptTag: /<script>/,
}

export const blockPageConstant = {
  pageTitleHtml: '<p class="title">',
  pTagClose: '</p>',
  bodyMessageHtml: '<p class="body-message" style="margin-top: 16px">',
  pageTitle: 'pageTitle',
  bodyMessage: 'bodyMessage',
  pageTitleAPIKey: 'title',
  bodyMessageAPIKey: 'body-message',
  html: 'html',
}

export const endpointStatus = {
  healthy: 'healthy',
  error: 'error',
  dormant: 'dormant',
  disabled: 'disabled',
  fallback: 'fallback',
  uninstalled: 'uninstalled',
  debugMode: 'debug mode',
}

export const ignoredEndpointStatusRegEx = /dormant|uninstalled/i

export const inflightDomian = 'https://inflight.dope.security'

export const downloadLinks = {
  releaseNotes: 'https://inflight.dope.security/release-notes',
}

export const EnterTab = 'TAB / ENTER'

export const value1 = 'value1'
export const value2 = 'value2'
export const throwError1 = 'throwError1'
export const throwError2 = 'throwError2'

export const policyErrorToast = 'update-policy-toast-Id'
export const settingErrorToast = 'update-setting-toast-Id'

export const nameField = [
  'Revert',
  'Save',
  'Cloud App',
  'Content',
  'Users',
  'Bypass',
  'Policy',
  'Analytics',
  'Take me there',
  'Analytics',
  'Endpoints',
  'Settings',
  'Disable Control',
  'Microsoft O365',
  'Google',
  'Box',
  'Salesforce',
  'Slack',
  'GitHub',
  'Dropbox',
  'Cisco WebEx',
  'Cancel',
]

export const input = 'INPUT'
export const span = 'SPAN'

export const enter = 'Enter'
export const tab = 'Tab'
export const numpadEnter = 'NumpadEnter'
export const escape = 'Escape'
export const backspace = 'Backspace'

/**
 * These are not roles but actions/permissions
 * When moved to backend, we need to update this to permissions
 * and update the components accordingly wherever they are in use
 */
export const roles = {
  addException: 'create:exception',
  assignUser: 'assign:policyUser',
  createBypass: 'create:bypass',
  updateBypass: 'update:bypass',
  casbReviewFiles: 'casb:reviewFiles',
  createCloudApp: 'create:cloudApp',
  createCustomCategory: 'create:customCategory',
  createPolicy: 'create:policy',
  createUrl: 'create:url',
  deleteBypass: 'delete:bypass',
  deleteCloudApp: 'delete:cloudApp',
  deleteCustomCategory: 'delete:customCategory',
  deleteException: 'delete:exception',
  deletePolicy: 'delete:policy',
  deleteUrl: 'delete:url',
  deleteUser: 'delete:user',
  disableCloudApp: 'disable:cloudApp',
  disableEndpoint: 'disable:endpoint',
  downloadEndpoint: 'download:endpoint',
  enableCloudApp: 'enable:cloudApp',
  enableEndpointDebugMode: 'enable:endpointDebugMode',
  generateToken: 'create:token',
  resetPolicy: 'reset:policy',
  viewSettingsUsers: 'view:settingsUsers',
  createCustomBlockPage: 'create:customBlockPage',
  configureSIEMBucket: 'configure:SIEMBucket',
  deleteSIEMBucket: 'delete:SIEMBucket',
  deleteBlockPage: 'delete:blockPage',
  revokeToken: 'delete:token',
  showSnackBar: 'show:snackBar',
  unshareCASBFile: 'unshare:CASBFile',
  updateApplicationBypass: 'update:applicationBypass',
  updatePassword: 'update:password',
  updateDropDown: 'update:DropDown',
  updateAssociatedDomain: 'update:associatedDomain',
  viewAdmin: 'view:admin',
  viewSSLErrorNotification: 'view:sslErrorNotification',
  viewUser: 'view:user',
}

export const allowedFileTypes = ['csv', 'txt']

export const bypassURLPrefix = '*.'

export const UnknownUser = 'UnknownUser'
export const emailSupport = 'Email Support'
export const helpDocs = 'Help Docs'

export const footerLinks = {
  patentLink: 'https://patents.google.com/patent/US11431755B1/',
}

export const actions = {
  add: 'add',
  delete: 'delete',
}
export const cacIconMap: Record<string, string> = {
  // keeping it lowercase for string comparison
  box: BoxIcon,
  'cisco webex': CiscoWebexIcon,
  dropbox: DropboxIcon,
  google: GoogleIcon,
  'microsoft 365': Microsoft365Icon,
  salesforce: SalesforceIcon,
  slack: SlackIcon,
}

export const defaultResizeHookOptions: {
  refreshMode?: 'debounce' | 'throttle'
  refreshRate: number
} = {
  refreshMode: 'debounce',
  refreshRate: 200,
}

/** Roughly one frame at 60fps for surfaces resized by an animation. */
export const animatedResizeHookOptions: {
  refreshMode?: 'debounce' | 'throttle'
  refreshRate: number
} = {
  refreshMode: 'throttle',
  refreshRate: 16,
}

export const asc = 'asc'
export const desc = 'desc'
export const locationId = 'locationId'

// These constants are deprecated - use ShareStatusEnum from interfaces/CASB.types.ts instead
// export const PUBLIC = 'PUBLIC'
// export const PRIVATE = 'PRIVATE'
// export const EXTERNAL = 'EXTERNAL'

// Platform constants - should be moved to an enum in interfaces/CASB.types.ts
// export const PLATFORMS = {
//   GOOGLE: 'google',
//   MICROSOFT: 'microsoft',
// } as const

// Drive type constants - should be moved to CASBDriveTypeEnum in interfaces/CASB.types.ts
// export const DRIVE_TYPES = {
//   PERSONAL: 'personal',
//   SHARED: 'shared',
//   BUSINESS: 'business',
//   DOCUMENT_LIBRARY: 'documentlibrary',
// } as const

export const DOM_ROLES = {
  BUTTON: 'button',
  LINK: 'link',
  OPTION: 'option',
  CHECKBOX: 'checkbox',
}

// Date formats
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_DATE_WITH_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'
export const DATE_DAY_MONTH_YEAR_FORMAT = 'dd MMM yyyy'
export const DATE_AT_TIME_12H_FORMAT = "dd MMM yyyy' at 'hh:mm aa"

// 1 day in milliseconds
export const DAY_IN_MILLISECONDS = 86400000

// block pages
export const defaultBlock = 'defaultblock'
export const defaultWarning = 'defaultwarning'

// upload file validation

export const INVALID_FILE = 'INVALID_FILE'
export const VALID_FILE = 'VALID_FILE'

// Export all keyboard constants
export * from './keycodes'
